import { withInstall } from '@ll-plus/utils'

import CodeEditor from './src/code-editor.vue'

export const LlCodeEditor = withInstall(CodeEditor)
export * from './src/config'
declare module 'vue' {
  export interface GlobalComponents {
    LlCodeEditor: typeof CodeEditor
  }
}
